import { trackDatadogRumAction } from 'services/DataDog';
import { MetricWriter } from 'experimentation-client-js';

export const metricWriter: MetricWriter = {
    namespace: 'experimentation',
    sendGaugeMetric: async (metricName, value, dimensions) => {
        trackDatadogRumAction(metricName, { value, ...dimensions });
    },
    sendCountMetric: async (metricName, value, dimensions) => {
        trackDatadogRumAction(metricName, { value, ...dimensions });
    },
};
